export function initializeBackToTop() {
  const button = document.querySelector('.back-to-top');
  if (!button) return;

  const updateVisibility = () => button.classList.toggle('show', window.scrollY > 300);

  updateVisibility();
  window.addEventListener('scroll', updateVisibility, { passive: true });
}
